// Slide 2 - Overview (moved from SlideOverview)
export default function Slide2() {
  return (
    <div className="w-full max-w-[1200px] relative z-10 px-6">
      <div className="absolute -right-20 -top-12">
        <div
          className="accent-blob"
          style={{
            background:
              "linear-gradient(135deg, rgba(99,102,241,0.36), rgba(16,185,129,0.22))",
          }}
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left: Heading + intro */}
        <div className="space-y-6 text-left">
          <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white text-xs uppercase tracking-widest font-bold border border-white/20">
            Our Expertise
          </span>

          <h2
            className="text-white font-extrabold leading-tight title-gradient"
            style={{
              fontSize: "clamp(36px, 6vw, 64px)",
              letterSpacing: "-0.02em",
            }}
          >
            Websites & Product Development
          </h2>

          <p
            className="text-white/85 max-w-xl"
            style={{ fontSize: "clamp(16px, 1.6vw, 20px)" }}
          >
            We deliver <span className="keyword">end-to-end solutions</span> —{" "}
            <span className="keyword">elegantly designed websites</span> and
            <span className="keyword"> robust products</span> engineered for{" "}
            <span className="keyword">scale</span>. From{" "}
            <span className="keyword">discovery</span> and UX to
            <span className="keyword"> engineering</span> and launch, our teams
            ship reliable digital experiences tailored to your goals.
          </p>

          <div className="flex flex-wrap gap-3 mt-4">
            <div className="inline-flex items-center gap-3 bg-white/6 px-4 py-2 rounded-full border border-white/10 text-white/90 shadow-sm">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="opacity-90"
              >
                <path
                  d="M3 12h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 6h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  opacity="0.6"
                />
              </svg>
              <span className="keyword">Discovery & Design</span>
            </div>

            <div className="inline-flex items-center gap-3 bg-white/6 px-4 py-2 rounded-full border border-white/10 text-white/90 shadow-sm">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 3v18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 12h18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  opacity="0.6"
                />
              </svg>
              <span className="keyword">Engineering & Scale</span>
            </div>
          </div>
        </div>

        {/* Right: Two polished cards with heading */}
        <div>
          <h2 className="text-white/90 past-title mb-3 title-gradient">
            Our Past Projects
          </h2>
          <div className="h-1 w-28 rounded-full bg-gradient-to-r from-indigo-400 via-indigo-300 to-emerald-300 mb-6 opacity-90" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="card-accent backdrop-blur-sm rounded-3xl p-6 border border-white/8 shadow-lg transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="flex items-center justify-between">
                <h3 className="text-white font-bold text-lg">
                  Website Development
                </h3>
              </div>

              <ul className="text-white/90 mt-4 space-y-3">
                <li className="project-item">
                  <a
                    href="https://mazville.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-3"
                  >
                    <span className="w-3 h-3 bg-emerald-400 rounded-full mt-2 shrink-0" />
                    <span className="project-name leading-tight">Mazville</span>
                  </a>
                </li>
                <li className="project-item">
                  <a
                    href="https://aanpublishing.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-3"
                  >
                    <span className="w-3 h-3 bg-emerald-400 rounded-full mt-2 shrink-0" />
                    <span className="project-name leading-tight">
                      AAN Publications
                    </span>
                  </a>
                </li>
                <li className="project-item">
                  <a
                    href="https://lextria.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-3"
                  >
                    <span className="w-3 h-3 bg-emerald-400 rounded-full mt-2 shrink-0" />
                    <span className="project-name leading-tight">Lextria</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="card-accent backdrop-blur-sm rounded-3xl p-6 border border-white/8 shadow-lg transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
              <div className="flex items-center justify-between">
                <h3 className="text-white font-bold text-lg">
                  Product Development
                </h3>
              </div>

              <ul className="text-white/90 mt-4 space-y-3">
                <li className="project-item">
                  <a
                    href="https://certgen.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-3"
                  >
                    <span className="w-3 h-3 bg-sky-400 rounded-full mt-2 shrink-0" />
                    <span className="project-name leading-tight">CertGen</span>
                  </a>
                </li>
                <li className="project-item flex items-start gap-3">
                  <span className="w-3 h-3 bg-sky-400 rounded-full mt-2 shrink-0" />
                  <span className="project-name leading-tight">Auto IP</span>
                </li>
                <li className="project-item flex items-start gap-3">
                  <span className="w-3 h-3 bg-sky-400 rounded-full mt-2 shrink-0" />
                  <span className="project-name leading-tight">IDF</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
